/// <amd-module name="ClemtexPay.LoginHook"/>
//
// Pre-login terms flip, shared by every ClemtexPay entry point (shopping,
// myaccount, checkout) so it runs wherever the shopper logs in.
//
// The site reads a customer's terms once, at login. Shoppers without real terms
// need the "Pay by Link" placeholder on their record BEFORE the native login
// request, or NetSuite's checkout rejects their order. We wrap
// Account.Login.Model.save: POST the email to the public deployment of
// bb_sl_web_checkout (which sets the placeholder only when terms are blank),
// then let the real login proceed. Best effort with a short timeout — login
// must never hang on us. Registrations are handled server-side by
// bb_ue_web_customer_terms.js. See "Web Checkout/PLAN.md".
//
define(
    'ClemtexPay.LoginHook',
    ['ClemtexPay.Checkout.Config', 'jQuery', 'underscore'],
    function (Config, jQuery, _) {
        'use strict';

        function preloginFlip(email) {
            var done = jQuery.Deferred();
            var finished = false;
            var finish = function () { if (!finished) { finished = true; done.resolve(); } };
            if (!email || !Config.PRELOGIN_URL) { finish(); return done.promise(); }
            // Native fetch, no custom headers (SuiteCommerce's jQuery prefilter
            // would add X-SC-Touchpoint and force a CORS preflight). text/plain
            // keeps it a simple request; the Suitelet JSON.parses the raw body.
            try {
                fetch(Config.PRELOGIN_URL, {
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'omit',
                    cache: 'no-store',
                    headers: { 'Content-Type': 'text/plain' },
                    body: JSON.stringify({ action: 'prelogin', email: email })
                }).then(finish, finish);
            } catch (e) {
                finish();
            }
            setTimeout(finish, Config.PRELOGIN_TIMEOUT_MS);
            return done.promise();
        }

        function install() {
            var LoginModel;
            // Not every application bundle ships the login model; a missing
            // module must not break the bundle, so resolve it at runtime.
            try { LoginModel = require('Account.Login.Model'); } catch (e) { return false; }
            if (!LoginModel || !LoginModel.prototype || LoginModel.prototype.__clemtexPayWrapped) return false;
            LoginModel.prototype.save = _.wrap(LoginModel.prototype.save, function (originalSave) {
                var self = this;
                var args = _.toArray(arguments).slice(1);
                var attrs = args[0] || {};
                var email = (attrs && attrs.email) || this.get('email') || '';
                var result = jQuery.Deferred();
                preloginFlip(String(email).trim().toLowerCase()).always(function () {
                    var saved = originalSave.apply(self, args);
                    if (saved && typeof saved.then === 'function') {
                        saved.then(function () { result.resolve.apply(result, arguments); },
                                   function () { result.reject.apply(result, arguments); });
                    } else {
                        result.resolve(saved);
                    }
                });
                return result.promise();
            });
            LoginModel.prototype.__clemtexPayWrapped = true;
            return true;
        }

        return { install: install, preloginFlip: preloginFlip };
    }
);
